import React, { useState } from "react";
import api from "../../../configs/api";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import FileDropzone from "../../ui/FileDropzone";
import ShowingFile from "../../ui/ShowingFile";
import { ACCEPT_IMAGES_TYPES_OBJECT, ACCEPT_PDF_TYPES_OBJECT, cityOptions, degreeOptions, districtOptions, MAX_SIZE_IMAGE, specializationOptions, yearsOfExperienceOptions } from "../../../utils/constants";
import CustomInput from "../../ui/custom-inputs/CustomInput";
import CustomTextarea from "../../ui/custom-inputs/CustomTextarea";
import GeneralSelect from "../../ui/custom-inputs/select-inputs/GeneralSelect";

export default function AddModal({ handleModal, setIsAdd, isAdd, setStatus }) {

  const [specialist, setSpecialist] = useState({
    fullName: "",
    email: "",
    phone: "",
    password: "",
    brief: "",
    city: "",
    district: "",
    degree: "",
    specialization: "",
    yearsOfExperience: "",
    gender: "male",
  });

  const [specialistImage, setSpecialistImage] = useState([]);
  const [graduationCertificate, setGraduationCertificate] = useState([]);
  const [resume, setResume] = useState([]);
  const [cardId, setCardId] = useState([]);

  async function handleSubmit(e) {
    e.preventDefault();

    try {
      const response = await api.post("/admin/add_specialist", {
        ...specialist,
        image: specialistImage?.[0]?.fileUrl,
        graduationCertificate: graduationCertificate?.[0]?.fileUrl,
        resume: resume?.[0]?.fileUrl,
        ID_card: cardId?.[0]?.fileUrl,
      });

      setStatus({
        show: true,
        icon: "success",
        title: "Specialist added successfully",
        description: "",
        showConfirmButton: false,
        timer: 5000,
      });
      setIsAdd(false);

      setSpecialistImage({
        parentName: "",
        email: "",
        phone: "",
        password: "",
        childName: "",
        birthday: "",
        childCondition: "",
      });

      setSpecialistImage([]);
      setGraduationCertificate([]);
      setResume([]);
      setCardId([]);
    } catch (error) {
      if (error.response.status === 409) {
        setStatus({
          show: true,
          icon: "error",
          title: "Email already exists",
          description: "",
          showConfirmButton: false,
          timer: 5000,
        });
      } else {
        setStatus({
          show: true,
          icon: "error",
          title: "Something went wrong, please try again later",
          description: "",
          showConfirmButton: false,
          timer: 5000,
        });
      }
      console.error("Error add user:", error);
    }
  }

  function handleInput(e) {
    setSpecialist({ ...specialist, [e.target.name]: e.target.value });
  }

  return (
    <>
      {/* Add Specialist Modal */}
      <div
        className={`fixed inset-0 z-50 ${isAdd ? "flex" : "hidden "
          } items-center justify-center p-10 bg-gray-800 bg-opacity-50 overflow-x-hidden overflow-y-auto`}
      >
        <div className='relative w-full h-[80%] max-w-2xl px-4 overflow-y-scroll '>
          {/* Modal content */}
          <div className='relative bg-white rounded-lg shadow dark:bg-gray-800'>
            {/* Modal header */}
            <div className='flex items-start justify-between p-5 border-b rounded-t dark:border-gray-700'>
              <h3 className='text-xl font-semibold dark:text-white'>
                Add new specialists
              </h3>
              <button
                onClick={() => handleModal(setIsAdd, false)}
                type='button'
                className='text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-700 dark:hover:text-white'
                data-modal-toggle='add-user-modal'
              >
                <svg
                  className='w-5 h-5'
                  fill='currentColor'
                  viewBox='0 0 20 20'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    fillRule='evenodd'
                    d='M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z'
                    clipRule='evenodd'
                  />
                </svg>
              </button>
            </div>
            {/* Modal body */}
            <div className='p-6 space-y-6'>
              <form onSubmit={(e) => handleSubmit(e)}>

                <div className="flex flex-col gap-y-2 items-center text-center mb-4 text-primary3">
                  <label>Specialist Image</label>

                  {specialistImage.length > 0 ?
                    <img className="w-[200px] h-[200px] rounded-full bg-primarytext-primary3" src={specialistImage?.[0]?.fileUrl} alt="specialist" />
                    :
                    <FileDropzone
                      setState={setSpecialistImage}
                      value={specialistImage}
                      filesAccept={ACCEPT_IMAGES_TYPES_OBJECT}
                      name="specialistImage"
                      maxSize={MAX_SIZE_IMAGE}
                    />
                  }
                </div>

                <div className='grid grid-cols-6 gap-6'>
                  <div className='col-span-6 lg:col-span-3'>
                    <label
                      htmlFor='fullName'
                      className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'
                    >
                      Full Name
                    </label>
                    <CustomInput
                      onChange={(e) => handleInput(e)}
                      type='text'
                      name='fullName'
                      id='fullName'
                      placeholder='Full Name'
                    />
                  </div>
                  <div className='col-span-6 lg:col-span-3'>
                    <label
                      htmlFor='phone'
                      className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'
                    >
                      Phone Number
                    </label>
                    <CustomInput
                      onChange={(e) => handleInput(e)}
                      type='number'
                      name='phone'
                      id='phone'
                      placeholder='Phone Number'
                    />
                  </div>
                  <div className='col-span-6 lg:col-span-3'>
                    <label
                      htmlFor='email'
                      className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'
                    >
                      Email
                    </label>
                    <CustomInput
                      onChange={(e) => handleInput(e)}
                      type='email'
                      name='email'
                      id='email'
                      placeholder='Email'
                    />
                  </div>
                  <div className='col-span-6 lg:col-span-3'>
                    <label
                      htmlFor='password'
                      className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'
                    >
                      password
                    </label>
                    <CustomInput
                      onChange={(e) => handleInput(e)}
                      type='password'
                      name='password'
                      id='password'
                      placeholder='password'
                    />
                  </div>
                  <div className='col-span-6 lg:col-span-3'>
                    <label
                      htmlFor='city'
                      className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'
                    >
                      City
                    </label>
                    <GeneralSelect
                      options={cityOptions}
                      handleChange={(val) => {
                        setSpecialist(prev => ({ ...prev, city: val?.value }))
                      }}
                      defaultValue={specialist?.city}
                      name={"city"}
                    />
                  </div>
                  <div className='col-span-6 lg:col-span-3'>
                    <label
                      htmlFor='district'
                      className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'
                    >
                      District
                    </label>
                    <GeneralSelect
                      options={districtOptions}
                      handleChange={(val) => {
                        setSpecialist(prev => ({ ...prev, district: val?.value }))
                      }}
                      defaultValue={specialist?.district}
                      name={"district"}
                    />
                  </div>
                  <div className='col-span-6 lg:col-span-3'>
                    <label
                      htmlFor='degree'
                      className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'
                    >
                      Degree
                    </label>
                    <GeneralSelect
                      options={degreeOptions}
                      handleChange={(val) => {
                        setSpecialist(prev => ({ ...prev, degree: val?.value }))
                      }}
                      defaultValue={specialist?.degree}
                      name={"degree"}
                    />
                  </div>
                  <div className='col-span-6 lg:col-span-3'>
                    <label
                      htmlFor='yearsOfExperience'
                      className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'
                    >
                      Experience Years
                    </label>
                    <GeneralSelect
                      options={yearsOfExperienceOptions}
                      handleChange={(val) => {
                        setSpecialist(prev => ({ ...prev, yearsOfExperience: val?.value }))
                      }}
                      defaultValue={specialist?.yearsOfExperience}
                      name={"yearsOfExperience"}
                    />
                  </div>
                  <div className='col-span-6 lg:col-span-3'>
                    <label
                      htmlFor='yearsOfExperience'
                      className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'
                    >
                      Gender
                    </label>
                    <RadioGroup
                      row
                      aria-labelledby='demo-row-radio-buttons-group-label'
                      name='row-radio-buttons-group'
                      value={specialist.gender}
                      onChange={(e) => handleInput(e)}
                    >
                      <FormControlLabel
                        name='gender'
                        value='female'
                        control={<Radio />}
                        label='Female'
                      />

                      <FormControlLabel
                        name='gender'
                        value='male'
                        control={<Radio />}
                        label='Male'
                      />
                    </RadioGroup>
                  </div>
                  <div className='col-span-6 lg:col-span-3'>
                    <label
                      htmlFor='specialization'
                      className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'
                    >
                      Specialization
                    </label>
                    <GeneralSelect
                      options={specializationOptions}
                      handleChange={(val) => {
                        setSpecialist(prev => ({ ...prev, specialization: val?.value }))
                      }}
                      defaultValue={specialist?.specialization}

                      name={"specialization"}
                    />
                  </div>
                  <div className='col-span-6 lg:col-span-6'>
                    <label
                      htmlFor='brief'
                      className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'
                    >
                      Brief
                    </label>
                    <CustomTextarea
                      onChange={(e) => handleInput(e)}
                      type='text'
                      name='brief'
                      id='brief'
                      placeholder='Brief'
                    />
                  </div>
                </div>
                <br />

                {/* Files */}
                <div className="flex gap-4 text-primary3 justify-center">
                  <div className="flex flex-col gap-y-2 text-center">
                    <label>Card Id</label>
                    {cardId?.length === 0 ?
                      <FileDropzone
                        setState={setCardId}
                        value={cardId}
                        filesAccept={{ ...ACCEPT_IMAGES_TYPES_OBJECT, ...ACCEPT_PDF_TYPES_OBJECT }}
                        name="specialistImage"
                        maxSize={MAX_SIZE_IMAGE}
                      />
                      :
                      <ShowingFile values={cardId} setValues={setCardId} />
                    }

                  </div>
                  <div className="flex flex-col gap-y-2 text-center">
                    <label>Resume</label>
                    {resume?.length === 0 ?
                      <FileDropzone
                        setState={setResume}
                        value={resume}
                        filesAccept={{ ...ACCEPT_IMAGES_TYPES_OBJECT, ...ACCEPT_PDF_TYPES_OBJECT }}
                        name="specialistImage"
                        maxSize={MAX_SIZE_IMAGE}
                      />
                      :
                      <ShowingFile values={resume} setValues={resume} />
                    }
                  </div>
                  <div className="flex flex-col gap-y-2 text-center">
                    <label>Graduation Certificate</label>
                    {graduationCertificate?.length === 0 ?
                      <FileDropzone
                        setState={setGraduationCertificate}
                        value={graduationCertificate}
                        filesAccept={{ ...ACCEPT_IMAGES_TYPES_OBJECT, ...ACCEPT_PDF_TYPES_OBJECT }}
                        name="specialistImage"
                        maxSize={MAX_SIZE_IMAGE}
                      />
                      :
                      <ShowingFile values={graduationCertificate} setValues={setGraduationCertificate} />
                    }
                  </div>
                </div>
                <br />
                <div className='flex items-center pt-5 mt-5 justify-center border-t border-gray-200 rounded-b dark:border-gray-700 '>
                  <button
                    className='text-white bg-primary hover:bg-buttonFocus focus:ring-4 focus:ring-buttonFocus font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-buttonHover dark:hover:bg-primary dark:focus:ring-buttonFocus'
                    type='submit'
                  >
                    Add Specialist
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
